/**
 * Shop / popup PDPs: shrink product H1 + variant titles to one line (no clipping).
 */
(function () {
  'use strict';

  var TITLE_SEL = '.product-page[data-workshop-city-pdp] .product-title';
  var VARIANT_SEL =
    '.product-page[data-workshop-city-pdp] .wcf-variant-card__title, ' +
    '.pcw-root .wcf-variant-card__title, ' +
    '.asw-root .wcf-variant-card__title';
  var MIN_TITLE = 13;
  var MIN_VARIANT = 9;
  var EPS = 0.2;
  var resizeTimer = 0;
  var lastW = 0;
  var scheduled = false;

  function setFs(el, px) {
    el.style.setProperty('font-size', px + 'px', 'important');
  }

  function baseFs(el, fallback) {
    var key = 'data-amc-fit-base';
    var stored = parseFloat(el.getAttribute(key));
    if (stored && stored > 0) return stored;
    el.style.removeProperty('font-size');
    var px = parseFloat(window.getComputedStyle(el).fontSize) || fallback;
    el.setAttribute(key, String(px));
    return px;
  }

  function overflowPx(el) {
    var o = el.style.overflow;
    var t = el.style.textOverflow;
    el.style.overflow = 'hidden';
    el.style.textOverflow = 'clip';
    /* force layout */
    void el.offsetWidth;
    var delta = el.scrollWidth - el.clientWidth;
    el.style.overflow = o;
    el.style.textOverflow = t;
    return delta;
  }

  function fitEl(el, minPx, fallbackMax) {
    if (!el || !el.isConnected) return;
    var maxPx = baseFs(el, fallbackMax);
    el.style.setProperty('white-space', 'nowrap', 'important');
    el.style.setProperty('max-width', '100%', 'important');
    el.style.setProperty('display', 'block', 'important');
    el.style.setProperty('box-sizing', 'border-box', 'important');
    el.style.setProperty('overflow', 'hidden', 'important');
    el.style.setProperty('text-overflow', 'clip', 'important');
    setFs(el, maxPx);

    if (el.clientWidth < 4) return;
    if (overflowPx(el) <= 1) {
      el.style.setProperty('overflow', 'visible', 'important');
      el.setAttribute('data-amc-fit', '1');
      return;
    }

    var lo = minPx;
    var hi = maxPx;
    var best = minPx;
    for (var i = 0; i < 28 && hi - lo > EPS; i++) {
      var mid = (lo + hi) / 2;
      setFs(el, mid);
      if (overflowPx(el) <= 1) {
        best = mid;
        lo = mid;
      } else {
        hi = mid;
      }
    }
    /* slight safety shrink for subpixel / font rounding */
    setFs(el, Math.max(minPx, best - 0.5));
    if (overflowPx(el) > 1) {
      setFs(el, minPx);
    }
    el.style.setProperty('overflow', 'visible', 'important');
    el.setAttribute('data-amc-fit', '1');
  }

  function fitAll() {
    document.querySelectorAll(TITLE_SEL).forEach(function (el) {
      fitEl(el, MIN_TITLE, 34);
    });
    document.querySelectorAll(VARIANT_SEL).forEach(function (el) {
      fitEl(el, MIN_VARIANT, 14);
    });
  }

  function scheduleFit() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      fitAll();
    });
  }

  function observe() {
    document.querySelectorAll(TITLE_SEL + ', ' + VARIANT_SEL).forEach(function (el) {
      if (el.__amcFitObs) return;
      el.__amcFitObs = true;
      var mo = new MutationObserver(function () {
        el.removeAttribute('data-amc-fit-base');
        scheduleFit();
      });
      mo.observe(el, { characterData: true, childList: true, subtree: true });
    });
    var page = document.querySelector('.product-page[data-workshop-city-pdp]');
    if (page && !page.__amcFitChildObs) {
      page.__amcFitChildObs = true;
      var childMo = new MutationObserver(function () {
        observe();
        scheduleFit();
      });
      childMo.observe(page, { childList: true, subtree: true });
    }
  }

  function boot() {
    lastW = window.innerWidth || 0;
    fitAll();
    observe();
    [50, 150, 400, 900].forEach(function (ms) {
      setTimeout(function () {
        observe();
        fitAll();
      }, ms);
    });
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        fitAll();
      }).catch(function () {});
    }
  }

  window.AmcProductTitleFit = {
    fitAll: fitAll,
    scheduleFit: scheduleFit,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('resize', function () {
    var w = window.innerWidth || 0;
    if (Math.abs(w - lastW) < 2) return;
    lastW = w;
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(fitAll, 60);
  });
  window.addEventListener('orientationchange', function () {
    setTimeout(fitAll, 120);
  });
})();
